import "../../../../styles/OrderProducListCard.scss";

import { Tag, tagTypes } from "../../../common/components/Tag";

import {Localization} from "../../../common/util/localization.jsx";
import ProductViewItem from "../product/ProductViewItem";
import PropTypes from "prop-types";
import React from "react";
import Scroll from "../../../common/components/Scroll";
import { withRouter } from "react-router-dom";

class OrderProductListCard extends React.PureComponent {
    constructor(props){
        super(props);

        this.oncClickSeeAll = this.oncClickSeeAll.bind(this);
        this.createList = this.createList.bind(this);
    }

    oncClickSeeAll(event) {
        this.props.onClickSwapPage(event, this.props.link);
    }

    createList() {
        const {
            deviceType,
            localization,
            products,
            addRemoveProductToTemporaryOrder,
            activeOrder,
            width,
            setModal,
            countingNode,
        } = this.props;
        const maxToRender = Math.floor((width-(deviceType=="xs"?0:200))/130)+1;
        const nodePrd = [];
        for(let i=0; i<products.length && i<maxToRender; i++) {
            nodePrd.push(
                <div className="item-wrapper" key={i}>
                    { activeOrder && (
                        <ProductViewItem
                            localization={localization}
                            product={products[i].product}
                            addRemoveProductToTemporaryOrder={addRemoveProductToTemporaryOrder}
                            activeOrder={activeOrder}
                            setModal={setModal}
                            countingNode={countingNode}
                        />
                    )}
                </div>
            );
        }
        return nodePrd;
    }

    render() {
        const {
            deviceType,
            localization,
            products,
            width,
            labelName,
            labelHeader,
        } = this.props;
        //size of left info window 
        const infoWidth = 200;
        //remaining width removin padding used for card
        const widthLeft = width-infoWidth;
        return (
            deviceType==="xs" ? (
                <div className="card-default">
                    <div className="list-card-info-xs">
                        <div className="list-info">
                            <div>
                                <div className="header">{labelHeader}</div>
                                <div className="name">{labelName}</div>
                            </div>
                            <button className="btn" onClick={this.oncClickSeeAll} style={{position:"absolute",right:"8px"}}>
                                {localization.text("order","card","seeAllCount",{count:products.length})}
                            </button>
                        </div>
                        <div className="list-prd">
                            {this.createList()}
                        </div>
                    </div>
                </div>
            ) : (
                <div className="card-default" style={{height:"247px"}}>
                    <div className="list-card-info" style={{maxWidth:`${width}px`}}>
                        <div className="list-info" style={{width:`${infoWidth}px`}}>
                            <div className="header">{labelHeader}</div>
                            <div className="name">{labelName}</div>
                            <div className="tag">
                                <Tag label={localization.text("order","countProducts",{count:products.length})} type={tagTypes.red} />
                            </div>
                            <button className="btn" onClick={this.oncClickSeeAll}>
                                {localization.text("order","card","seeAll")}
                            </button>
                        </div>
                        <Scroll className="list-prd" shadowY={false} shadowStyle={{borderBottomRightRadius:"8px", borderTopRightRadius:"8px"}} style={{width:`${widthLeft}px`, overflow:"hidden"}}>
                            {this.createList()}
                        </Scroll>
                    </div>
                </div>
            )
        );
    }
}

OrderProductListCard.propTypes = {
    //Required
    deviceType: PropTypes.string.isRequired,
    localization: Localization.propTypes.isRequired,
    activeOrder: PropTypes.object.isRequired,
    addRemoveProductToTemporaryOrder: PropTypes.func.isRequired,
    width: PropTypes.number.isRequired,
    products: PropTypes.array.isRequired,
    labelHeader: PropTypes.string.isRequired,
    labelName: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    onClickSwapPage: PropTypes.func.isRequired,
    setModal: PropTypes.func.isRequired,
    countingNode: PropTypes.node.isRequired,
};

export default withRouter(OrderProductListCard);